


let lazyLoad = null

const lazyLoadUpdate = () => {
    lazyLoad?.update();
}
/**
 * index thule
 */
const ready = (callback) => {
    if (document.readyState !== "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
};

ready(async () => {
    let {initLazyLoad} = await import('./common/lazyload');
    lazyLoad = await initLazyLoad();
    let {Thule} = await import("./thule");

    let noResultsFound = 'No results found';
    const configurator = document.getElementById('configurator');
    if (configurator) {
        noResultsFound = configurator.getAttribute('data-select-no-results');
    }
    const thuleSelectOptions = {
        lockOptgroupOrder: true,
        maxOptions: null,
        render: {
            option: function (data) {
                if (data.src) {
                    return `<span class="row row-cols-2 align-items-center gx-2"><span class="col-2"><img class="img-fluid" src="${data.src}" alt="${data.text}"></span><span class="col">${data.text}</span></span>`;
                }
                return `<div class="row row-cols-1 align-items-center gx-2"><span class="col">${data.text}</span></div>`;
            },
            no_results: function () {
                return `<div class="no-results">${noResultsFound}</div>`;
            },
        }
    };

    new Thule(
        '/api/v1/thule',
        'thuleProductFilter',
        'thuleProductFilter-wrapper',
        'thuleProductFilter-orderer',
        'thuleProductFilter-illustrateProduct',
        'thuleProductFilter-products',
        'thuleProductFilter-filter',
        'thuleProductFilter-pager',
        'thuleProductFilter-pagerBottom',
        'thuleProductFilter-count',
        'thuleProductFilter-configuratorSelect',
        'configurator',
        'thuleProductFilter-link',
        'thuleProductFilter-select',
        'thuleProductFilter-price',
        'js-site-backdrop',
        thuleSelectOptions,
        () => lazyLoadUpdate()

    );
    let thuleSelectList = document.querySelectorAll('.thule-select');
    if (thuleSelectList.length) {
        let {default: TomSelect} = await import("tom-select");
        thuleSelectList.forEach(function (thuleSelect) {
            new TomSelect(thuleSelect, thuleSelectOptions);
        })
    }
    let {jsSubmenuInit} = await import('./common/js-submenu.js');
    jsSubmenuInit(() => lazyLoadUpdate());
    let {collapseInit} = await import('./common/collapse');
    collapseInit();
    let {modalInit} = await import('./common/modal');
    modalInit();
    const {initNewsletter} = await import('./common/newsletter');
    initNewsletter();
    const {initPaddingTopSiteContent} = await import('./common/site-content');
    initPaddingTopSiteContent();
});

